  import React from 'react';
  import { Navigate, Outlet } from 'react-router-dom';
  import { useEffect, useState } from 'react';
  import { useAuth } from '../context/AuthContext';
import apiService from '../services/ApiService';

  const useAuthStatus = () => {
      const [authenticated, setAuthenticated] = useState<boolean | null>(null);

      useEffect(() => {
        apiService.get('/auth/status')
          .then(res =>  
            setAuthenticated(res) // Assuming the API returns an object with an 'authenticated' property
          )
          .catch(() => setAuthenticated(false));
      }, []);

      return authenticated;
  };

  const RequireAuth: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    // const authenticated = useAuthStatus();
    const { authenticated } = useAuth();

    if (authenticated === null) {
      // Optionally, show a loading indicator while checking auth status
      return <div>Loading...</div>;
    }

    if (!authenticated) {
      return <Navigate to="/login" replace />;
    }

    // If children are provided, render them; otherwise, render an <Outlet />
    return <>{children ? children : <Outlet />}</>;
  };

  export default RequireAuth;